import { TOC } from "./data";
import { PageFooter, Corner } from "./chrome";

export default function TOCPage() {
  return (
    <section className="page" data-testid="page-toc">
      <div className="grain" />
      <Corner section="Contents" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Inside This Brochure</div>
          <h2 className="h-title">A guided tour of <em>our work,</em><br />our people and our promise.</h2>
        </div>
        <div className="toc-grid">
          {TOC.map((t) => (
            <div className="toc-row" key={t.num}>
              <div className="num">{t.num}</div>
              <div className="name">
                {t.name}
                <small>{t.sub}</small>
              </div>
              <div className="pg">P · {t.pg}</div>
            </div>
          ))}
        </div>
      </div>
      <PageFooter num="02" />
    </section>
  );
}
